import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import * as api from "../../common/manipurCommon/API";
import * as func from "../../common/manipurCommon/FunctionCalls";
import Utils from "../../common/manipurCommon/Utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, } from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";

const ExternalAthletes = () => {

    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [internalAthleteList, setInternalAthleteList] = useState<any[]>([]);
    const [sportsList, setSportsList] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [athleteName, setAthleteName] = useState("");
    const [athleteId, setAthleteId] = useState("");
    const [extAthleteId, setExtAthleteId] = useState("");
    const [dob, setDob] = useState("");
    const [genderId, setGenderId] = useState("");
    const [sportId, setSportId] = useState("");
    const [athleteStatus, setAthleteStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const genderList = [{ extComGenderId: 1, extComGenderName: "Men" }, { extComGenderId: 2, extComGenderName: "Women" }];

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    useEffect(() => {
        fetchExternalAthletes();
    }, []);

        async function fetchExternalAthletes() {
            setIsLoading(true);
            const externalAthletesResponse = await func.externalCompAthletes(null);
            setAthleteList(Array.isArray(externalAthletesResponse) ? externalAthletesResponse : [])
            setIsLoading(false);
        }

    const filteredData = athleteList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const athleteRender = (rowData) => {
        return <span>{rowData.extComAthleteName}</span>;
    };

    const internalAthleteIdRender = (rowData) => {
        return <span>{rowData.athleteName}</span>;
    }

    const dobRender = (rowData) => {
        return <span>{formatDate(rowData.extComDOB)}</span>;
    }

    const statusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editAthlete(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const ctgryId = rowData.extComAthleteId;
        return (
            <Link to="#" onClick={() => deleteAthlete(ctgryId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function newAthlete() {
        setIsEdit(false);
        const intAthltResponse = await func.hpcBatchAthelete(null);
        setInternalAthleteList(Array.isArray(intAthltResponse) ? intAthltResponse : [])
        const sportResponse = await func.externalSports(null);
        setSportsList(Array.isArray(sportResponse) ? sportResponse : [])
        setDob("");
        setSportId("");
        setAthleteId("");
        setAthleteName("");
        setOpenModal(true);
    }

    async function editAthlete(rowData: { extComAthleteId: any; }) {
        const athltId = rowData.extComAthleteId;
        setIsEdit(true)
        setOpenModal(true)
        const sportResponse = await func.externalSports(null);
        setSportsList(Array.isArray(sportResponse) ? sportResponse : [])
        const getDetails = await func.externalCompAthletes(athltId);
        setAthleteId(getDetails.athleteId);
        setExtAthleteId(getDetails.extComAthleteId);
        setAthleteName(getDetails.extComAthleteName);
        setDob(getDetails.extComDOB);
        setAthleteStatus(getDetails.status);
        setSportId(getDetails.extComSportId);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateAthlete();
            } else {
                const formData = new FormData();
                formData.append("extComAthleteName", athleteName);
                formData.append("athleteId", athleteId);
                formData.append("extComGenderId", genderId);
                formData.append("extComDOB", dob);
                formData.append("extComSportId", sportId);

                const createAthlete = api.ExternalCompetitionAthletes;
                fetch(createAthlete, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    // window.location.reload(); // 🔁 Reload only after OK is clicked
                                    setOpenModal(false);
                                    fetchExternalAthletes();
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            })
                        }
                    })
            }
        }
    }

    function updateAthlete() {
        const formData = new FormData();
        formData.append("extComAthleteName", athleteName);
        formData.append("athleteId", athleteId);
        formData.append("extComDOB", dob);
        formData.append("extComGenderId", genderId);
        formData.append("extComSportId", sportId);
        formData.append("status", athleteStatus);
        const updateCompTyp = api.ExternalCompetitionAthletes + "/" + extAthleteId;
        fetch(updateCompTyp, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setIsEdit(false);
                            setOpenModal(false);
                            fetchExternalAthletes();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function deleteAthlete(athltId) {
        const delAthlt = api.ExternalCompetitionAthletes + "/" + athltId + "/0";
        fetch(delAthlt, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setOpenModal(false);
                            fetchExternalAthletes();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    return (
        <>{isLoading && (
            <div id="global-loader">
                <div className="loader-img">
                    <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                </div>
            </div>
        )}
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Athletes</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newAthlete() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Athlete">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                            </div>
                            <div className="row col-lg-12 mb-10">
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComAthleteName"
                                                header="Athlete Name"
                                                body={athleteRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="athleteId"
                                                header="Athlete ID"
                                                body={internalAthleteIdRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComDOB"
                                                header="Date of Birth"
                                                body={dobRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="status"
                                                header="Status"
                                                body={statusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                size="md"
                centered
                show={openModal}>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Athlete</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="input-space">
                                    <label className="form-label">Athlete</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="athleteName"
                                        value={athleteName}
                                        onChange={(e) => { setAthleteName(e.target.value) }}
                                        placeholder="Enter Athlete Name" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="input-space">
                                    <label className="form-label">Internal Athlete?</label>
                                    <Select
                                        value={internalAthleteList.find(athlt => athlt.athleteId === athleteId) ? {
                                            value: athleteId,
                                            label: internalAthleteList.find(athlt => athlt.athleteId === athleteId).athleteName
                                        } : null}
                                        onChange={(e) => {
                                            setAthleteId(e.value);
                                        }}
                                        styles={customSelect}
                                        options={internalAthleteList.map(athlt => ({
                                            value: athlt.athleteId,
                                            label: athlt.athleteName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="input-space">
                                    <label className="form-label">Gender</label>
                                    <Select
                                        value={genderList.find(gender => gender.extComGenderName === genderId) ? {
                                            value: genderId,
                                            label: genderList.find(gender => gender.extComGenderName === genderId)?.extComGenderName ?? genderId
                                        } : null}
                                        onChange={(e: any) => {
                                            if (e) {
                                                setGenderId(e.value);
                                            }
                                        }}
                                        // styles={customSelect}
                                        required
                                        options={genderList.map(gender => ({
                                            value: gender.extComGenderName,
                                            label: gender.extComGenderName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="input-space">
                                    <label className="form-label">Date of Birth</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        required
                                        name="dob"
                                        value={dob}
                                        onChange={(e) => { setDob(e.target.value) }}
                                        placeholder="Enter Date of Birth" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="input-space">
                                    <label className="form-label">Sport</label>
                                    <Select
                                        value={sportsList.find(sprt => sprt.extComSportId === sportId) ? {
                                            value: sportId,
                                            label: sportsList.find(sprt => sprt.extComSportId === sportId).extComSportName
                                        } : null}
                                        onChange={(e) => {
                                            setSportId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={sportsList.map(sprt => ({
                                            value: sprt.extComSportId,
                                            label: sprt.extComSportName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            {isEdit ?
                                <>
                                    <div className="row">
                                        <div className="mb-10 col-lg-6" style={{ paddingTop: "1rem" }}>
                                            <label className="form-label">Status</label>
                                        </div>
                                        <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                            <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                <input
                                                    className="form-check-input text-end"
                                                    type="checkbox"
                                                    checked={athleteStatus === '1'}
                                                    id="athleteStatus"
                                                    onChange={(e) => {
                                                        setAthleteStatus(e.target.checked ? '1' : '0')
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </> : null
                            }
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />Save</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
        </>
    );
};

export default ExternalAthletes;